export var DataOriginTypeEnum;
(function (DataOriginTypeEnum) {
    DataOriginTypeEnum["RACE"] = "race";
    DataOriginTypeEnum["CLASS"] = "class";
    DataOriginTypeEnum["CLASS_FEATURE"] = "class-feature";
    DataOriginTypeEnum["CONDITION"] = "condition";
    DataOriginTypeEnum["BACKGROUND"] = "background";
    DataOriginTypeEnum["FEAT"] = "feat";
    DataOriginTypeEnum["ITEM"] = "item";
    DataOriginTypeEnum["RULE_DATA"] = "rule-data";
    DataOriginTypeEnum["CUSTOM"] = "custom";
    DataOriginTypeEnum["SIMULATED"] = "simulated";
    DataOriginTypeEnum["ADHOC"] = "adhoc";
    DataOriginTypeEnum["VEHICLE"] = "vehicle";
    DataOriginTypeEnum["FEAT_LIST"] = "feat-list";
    DataOriginTypeEnum["UNKNOWN"] = "unknown";
})(DataOriginTypeEnum || (DataOriginTypeEnum = {}));
export var DataOriginDataInfoKeyEnum;
(function (DataOriginDataInfoKeyEnum) {
    DataOriginDataInfoKeyEnum["PRIMARY"] = "primary";
    DataOriginDataInfoKeyEnum["PARENT"] = "parent";
})(DataOriginDataInfoKeyEnum || (DataOriginDataInfoKeyEnum = {}));
